<div class="simple-datepicker">
    <div class="tool">
            <div class="form-group">
                <div class="input-group">
                    <button class="btn btn-outline-secondary calendar dp" type="button" (click)="toggleCalendar()">
                        <em class="fa fa-calendar dp"></em>
                    </button>
                    <input  onkeypress="return false;" [value]="displayedDate" (click)="toggleCalendar()" class="dp">
                    <div #datepickerContainer style="display: none">
                        <ngb-datepicker class="current-dp" #dp [(ngModel)]="selectedDate" 
                                        (select)="onDateSelected($event)"
                                        [maxDate]="maxDate"
                                        [minDate]="minDate"
                                        >
                        </ngb-datepicker>
                    </div>
                </div>
            </div>
    </div>
</div>